import cx from 'classnames'
import MarkdownIt from 'markdown-it'
import PropTypes from 'prop-types'
import React, { useRef } from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'


const decorators = [
  memoized,
]

function MarkdownText(props) {
  const { classes, className, source, tag, inline, rendererProps, ...otherProps } = props
  const md = useRef(new MarkdownIt({ breaks: true, html: true, ...rendererProps }))

  const html = source && (inline ? md.current.renderInline(source) : md.current.render(source))
  const Tag = tag || 'div'

  return (
    <Tag
      {...otherProps}
      className={cx(classes.container, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

MarkdownText.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  source: PropTypes.string,
  tag: PropTypes.elementType,
  inline: PropTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  rendererProps: PropTypes.object,
}

MarkdownText.defaultProps = {
  classes: {},
  className: null,
  source: '',
  tag: 'div',
  inline: false,
  rendererProps: null,
}

MarkdownText = chainDecorators(decorators, MarkdownText)

export default MarkdownText
